import {
  buildSessionPrescriptionSections,
  buildWorkoutPrescriptionSections,
  formatTotalWorkoutDuration,
} from "@/lib/workoutPrescriptionFormatters";

const StepBlock = ({ item }) => (
  <div className="rounded-md border border-dark-border/70 bg-dark-surface px-3 py-2">
    <div className="flex flex-wrap items-baseline justify-between gap-2">
      <div className="text-sm text-dark-text-primary">
        {item.headline || item.label}
      </div>
      {item.duration && (
        <div className="text-xs text-dark-text-muted">{item.duration}</div>
      )}
    </div>
    {item.intensity && (
      <div className="mt-1 text-xs text-dark-text-secondary">{item.intensity}</div>
    )}
    {item.cue && (
      <div className="mt-1 text-xs text-dark-text-muted whitespace-pre-wrap">
        {item.cue}
      </div>
    )}
    {item.substeps?.length > 0 && (
      <div className="mt-2 space-y-2 border-l border-dark-border pl-3">
        {item.substeps.map((sub, index) => (
          <StepBlock key={`${sub.label}-${index}`} item={sub} />
        ))}
      </div>
    )}
  </div>
);

export const SessionPrescriptionView = ({
  session,
  template = null,
  testId = "session-prescription-view",
}) => {
  const fromSession = buildSessionPrescriptionSections(session);
  const sections = fromSession.length
    ? fromSession
    : buildWorkoutPrescriptionSections(template);
  const total = formatTotalWorkoutDuration(template, session?.duration_minutes);

  if (!sections.length) {
    return (
      <p className="text-sm text-dark-text-secondary" data-testid={`${testId}-empty`}>
        Structured steps are not available for this session. Complete the planned
        duration at the session effort.
      </p>
    );
  }

  return (
    <div className="space-y-4" data-testid={testId}>
      {session?.prescription_customized && (
        <div className="app-badge border-brand-primary/40 text-brand-primary text-[10px]">
          Custom prescription
        </div>
      )}
      {sections.map((section) => (
        <div key={section.key}>
          <div className="text-[11px] uppercase tracking-[0.25em] text-dark-text-muted">
            {section.title}
          </div>
          <div className="mt-2 space-y-2">
            {section.items.map((item, index) => (
              <StepBlock key={`${section.key}-${index}`} item={item} />
            ))}
          </div>
        </div>
      ))}
      {total && (
        <div className="text-xs uppercase tracking-widest text-dark-text-muted">
          Total · {total}
        </div>
      )}
    </div>
  );
};
